export enum SecondaryFactor {
  EMAIL = 'email',
  SMS = 'sms',
  PUSH = 'push',
}

export * from './sca'
